import React from 'react';
import { useDemandFilters } from '@/features/demands/hooks/useDemandFilters';
import AdvancedFilters, { FilterConfig } from '@components/AdvancedFilters';

/**
 * Versão mobile dos filtros de demanda.
 * Usa o componente centralizado AdvancedFilters em modo mobile.
 */
export const MobileDemandFilters: React.FC = () => {
  // Garante que side-effects/config de filtros sejam aplicados
  useDemandFilters();

  const filterConfig: FilterConfig = {
    showClientFilter: true,
    showDateRangeFilter: true,
    showCategoryFilter: true,
    showStatusFilter: true,
    showPriorityFilter: true,
    showQrCodeFilter: true,
    showSimilarOnlyFilter: true,
    showAssigneeFilter: true,
    showProviderFilter: true,
    pageType: 'demands',
    variant: 'mobile',
  };

  return <AdvancedFilters config={filterConfig} />;
};

export default MobileDemandFilters;
